import { render, staticRenderFns } from "./WizardPropiedad.vue?vue&type=template&id=a799caf6&scoped=true"
import script from "./WizardPropiedad.vue?vue&type=script&lang=js"
export * from "./WizardPropiedad.vue?vue&type=script&lang=js"
import style0 from "./WizardPropiedad.vue?vue&type=style&index=0&id=a799caf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a799caf6",
  null
  
)

export default component.exports